export enum AssetTypes {
  Movie = "Movie",
  Video = "Video",
  CreatorVideo = "Creator Video",
  TVSeries = "TV Series",
  LiveTV = "LiveTV",
  Podcast = "Podcast",
  Music = "Music",
  Radio = "Radio",
  PayPerView = "PPV",
  Other = "Other",
}
